import {
  useFetchCollCalcEnumValues,
  useFetchCrmEnumValues,
  useFetchDatamart2EnumValues,
  useFetchDatamartEnumValues,
  useFetchLegalEntityDataReplicatorEnumValues,
  useFetchLifeDataReplicatorEnumValues,
  useFetchLifeEnumValues,
  useFetchMoneyInEnumValues,
  useFetchMoneyOutEnumValues,
  useFetchUnitlinkDataReplicatorEnumValues,
  useFetchUnitLinkEnumValues,
} from '@festina-life/api'
import type { ServerWithTest } from '@festina-life/core'
import { notEmpty } from '@festina-life/core'

type Props = {
  component: ServerWithTest
  enumType: string
}

export const useFetchOperationsEnums = ({ component, enumType }: Props) =>
  ({
    life: useFetchLifeEnumValues,
    lifeDataReplicator: useFetchLifeDataReplicatorEnumValues,
    moneyIn: useFetchMoneyInEnumValues,
    moneyOut: useFetchMoneyOutEnumValues,
    legalEntity: useFetchCrmEnumValues,
    legalEntityDataReplicator: useFetchLegalEntityDataReplicatorEnumValues,
    unitLinkDataReplicator: useFetchUnitlinkDataReplicatorEnumValues,
    collCalc: useFetchCollCalcEnumValues,
    unitLink: useFetchUnitLinkEnumValues,
    dataMart: useFetchDatamartEnumValues,
    dataMart2: useFetchDatamart2EnumValues,
  })[component](
    { name: enumType },
    {
      select: (data) =>
        data?.literals?.map((x) => x?.name).filter(notEmpty) ?? [],
    },
  )
